export enum TransactionErrorActionEnum {
  Refund = 0, // Återbetalning
  Deposit = 1, // Gåva
  Memberfee = 2, // Medlemsavgift
  Purchase = 3, // Köp
  Subscription = 4, // Prenumeration
}
